import React from 'react'

import { Typo } from 'components/_old/Typo'

import Toggle from '../Toggle'
import { type ToggleProps } from '../Toggle/Toggle'
import { Typography } from '../Typography'

import './LabelledToggle.css'

type LabelledToggleProps = ToggleProps & {
  label: string | React.ReactNode
}

const LabelledToggle = ({ label, ...rest }: LabelledToggleProps): JSX.Element => {
  return (
    <Typography tag="label" align="left" size={16} lineHeight="small" className="LabelledToggle">
      <Toggle {...rest} />
      <Typo>{label}</Typo>
    </Typography>
  )
}

export { LabelledToggle }
